/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-28 11:35:45
 */
export class IndexInfomationNavModel {
  id: string
  title: string
  constructor (id: string, title: string) {
    this.id = id
    this.title = title
  }
}

export class SystemLessionTag {
  id: string
  title: string
  poster: string
  display: string
  category: string
  children: Array<SystemLessionTag>
  constructor (id: string, title: string, poster: string, display: string, category: string, children: Array<SystemLessionTag>) {
    this.id = id
    this.title = title
    this.poster = poster
    this.display = display
    this.category = category
    this.children = children
  }
}

export class Lecturer {
  id: string
  name: string
  icon: string
  intrduction: string
  job: string
  constructor (id: string, name: string, icon: string, intrduction = '', job = '') {
    this.id = id
    this.icon = icon
    this.name = name
    this.intrduction = intrduction
    this.job = job
  }
}

export class StudyPlan {
  id: string
  title: string
  poster: string
  lessions: Array<any>
  constructor (id: string, title: string, poster: string, lessions: Array<any>) {
    this.id = id
    this.title = title
    this.poster = poster
    this.lessions = lessions
  }
}

export class SelectedCourse {
  coursewareId: string
  learnPlanId: string
  resourceUrl: string
  coverUrl: string
  title: string
  playNum: string
  constructor (coursewareId: string, learnPlanId: string, resourceUrl: string, coverUrl: string, title: string, playNum = '') {
    this.coursewareId = coursewareId
    this.learnPlanId = learnPlanId
    this.coverUrl = coverUrl
    this.resourceUrl = resourceUrl
    this.title = title
    this.playNum = playNum
  }
}

export class Video {
  accessKeyId: string
  accessKeySecret: string
  accessToken: string
  playAuth?: string
  constructor (accessKeyId: string, accessKeySecret: string, accessToken: string, playAuth?: string) {
    this.accessKeyId = accessKeyId
    this.accessKeySecret = accessKeySecret
    this.accessToken = accessToken
    this.playAuth = playAuth
  }
}
